export default __webpack_public_path__ + "static/media/Toronto_.77226176.jpg";